import { Location_GetGoAheadLocations } from 'apiV2/Location';

export const useLocationApi = () => {
  const getGoAheadLocations = async () => await Location_GetGoAheadLocations();

  return {
    getGoAheadLocations,
  };
};
